import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import "../../../../../assets/css/module-ui.css";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import { PulseLoader } from "react-spinners";

const pageStyle = `
  .config-table-scroll {
    width: 100%;
    max-width: 100%;
    max-height: 570px;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch;
  }

  .config-table {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    table-layout: fixed !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
  }

  .config-table thead th {
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    padding: 12px 14px !important;
    background: #f3f5ff !important;
    color: #25345f !important;
    border-right: 1px solid #e1e6ef !important;
    border-bottom: 1px solid #dbe2ee !important;
    font-size: 13px !important;
    font-weight: 700 !important;
    text-align: center !important;
    vertical-align: middle !important;
  }

  .config-table tbody td {
    padding: 12px 14px !important;
    background: #fff !important;
    color: #2b3654 !important;
    border-right: 1px solid #e6ebf3 !important;
    border-bottom: 1px solid #edf0f5 !important;
    font-size: 12.5px !important;
    vertical-align: middle !important;
  }

  .config-table thead th:last-child,
  .config-table tbody td:last-child {
    border-right: 0 !important;
  }

  .config-table tbody tr:hover td {
    background: #fafbff !important;
  }

  .config-toggle-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 30px;
  }

  .config-toggle-wrap .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 0;
    margin: 0 !important;
    padding: 0 !important;
  }

  .config-toggle-wrap .form-check-input {
    margin: 0 !important;
    cursor: pointer;
  }

  @media (max-width: 780px) {
    .config-table-scroll {
      max-height: 520px;
    }

    .config-table thead th,
    .config-table tbody td {
      padding: 10px 8px !important;
      font-size: 11.5px !important;
    }
  }
`;

export default function PengaturanDimensi() {
  document.title = "Pengaturan Dimensi";

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [keyword] = useState("");

  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({
    query: "(max-width: 780px)",
  });

  const storageLevel = localStorage.getItem("level");

  const [isFetching, setIsFetching] = useState(false);
  const [getData, setGetData] = useState([]);

  const idUser = localStorage.getItem("id_admin") || "";
  const outputIdUser = idUser.replace(/[|&;$%@"<>()+,]/g, "");

  const location = useLocation();
  const navigate = useNavigate();

  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems =
      JSON.parse(localStorage.getItem("role_permission")) || [];

    if (level === "developer" || level === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1,
      });
      return;
    }

    const foundPermission = storageItems.find(
      (item) => item.menu?.url === location.pathname
    );

    if (!foundPermission) {
      navigate("/dashboard");
      return;
    }

    setPermission({
      create: foundPermission.create,
      read: foundPermission.read,
      update: foundPermission.update,
      delete: foundPermission.delete,
    });
  }, [location.pathname, navigate]);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const GetResponseData = useCallback(async () => {
    try {
      const response = await APILA.get(
        `/api/access/dimensis?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&ascending_name=true&`,
        fetchParams
      );

      if (response?.status === 200) {
        setGetData(response.data.data || []);
      }
    } catch (error) {
      swal({
        title: "Failed",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Terjadi kesalahan",
        icon: "error",
        timer: 3000,
        buttons: false,
      });
    }
  }, [ascending, fetchParams, keyword, limit, page]);

  useEffect(() => {
    const loadData = async () => {
      setIsFetching(true);

      try {
        await GetResponseData();
      } finally {
        setIsFetching(false);
      }
    };

    loadData();
  }, [GetResponseData]);

  const saveForm = async (id, status) => {
    try {
      const response = await APILA.put(
        `/api/config-list-dimensi/${id}`,
        {
          status,
          user_id: outputIdUser,
        },
        fetchParams
      );

      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: response.data.message,
        });

        await GetResponseData();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          error.message ||
          "Gagal menyimpan perubahan",
      });

      await GetResponseData();
    }
  };

  const handleToggle = (row) => {
    const newStatus = Number(row?.status) === 1 ? 0 : 1;

    setGetData((prev) =>
      prev.map((item) =>
        item.id === row.id
          ? {
              ...item,
              status: newStatus,
            }
          : item
      )
    );

    saveForm(row.id, newStatus);
  };

  return (
    <>
      <style>{pageStyle}</style>

      <div className="body module-page assessment-page">
        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faGear} />
              </span>

              <h4 className="page-title-text">
                Konfigurasi Nilai
              </h4>
            </div>
          </div>

          <nav
            aria-label="breadcrumb"
            className="custom-breadcrumb-nav mt-4"
          >
            <ol className="custom-breadcrumb">
              <li className="custom-breadcrumb-item">
                <Link to="/dashboards-main">
                  Beranda
                </Link>
              </li>

              <li className="custom-breadcrumb-separator">
                /
              </li>

              <li className="custom-breadcrumb-item">
                <Link to="/element-recaps-dimensi">
                  Penilaian
                </Link>
              </li>

              <li className="custom-breadcrumb-separator">
                /
              </li>

              <li
                className="custom-breadcrumb-item active"
                aria-current="page"
              >
                Konfigurasi Nilai
              </li>
            </ol>
          </nav>
        </div>

        <div className="body-content module-content">
          {/* TAB MENU */}
          {/* <div className="assessment-mode-tabs">
            <div>
              <button className="btn assessment-mode-tab">
                <Link to="/dimensi-configs">
                  Konfigurasi Nilai Guru
                </Link>
              </button>
            </div>

            <div className="ml-2">
              <button className="btn assessment-mode-tab">
                <Link to="/dimensi-config-heads-new">
                  Konfigurasi Nilai Kepala Sekolah
                </Link>
              </button>
            </div>

            <div className="ml-2">
              <button
                className="btn assessment-mode-tab active"
                style={{
                  backgroundColor: "#076db5ff",
                  color: "#fff",
                }}
              >
                Konfigurasi Dimensi
              </button>
            </div>
          </div>

          <hr className="assessment-mode-divider" /> */}

          {/* =========================================================
    TAB MENU
    ========================================================= */}

<div className="assessment-mode-tabs">

  <div>
    <button className="btn assessment-mode-tab">
      <Link to="/element-recaps-dimensi/dimensi-configs">
        Konfigurasi Nilai Guru
      </Link>
    </button>
  </div>


  <div className="ml-2">
    <button className="btn assessment-mode-tab">
      <Link to="/element-recaps-dimensi/dimensi-config-heads-new">
        Konfigurasi Nilai Kepala Sekolah
      </Link>
    </button>
  </div>


  <div className="ml-2">
    <button className="btn assessment-mode-tab active">
      Konfigurasi Dimensi
    </button>
  </div>

</div>

<hr className="assessment-mode-divider" />

          {/* LOADER */}
          {isFetching && (
            <div
              className="text-center"
              style={{
                padding: "16px 0",
              }}
            >
              <PulseLoader
                color="#4368c5"
                size={12}
              />
            </div>
          )}

          {/* TABLE */}
          {!isFetching && (
            <div className="mt-3">
              <div className="module-table-card">
                <div className="module-table-scroll config-table-scroll">
                  <table
                    className="module-table config-table"
                    id="basic-datatable"
                  >
                    <colgroup>
                      <col style={{ width: "90px" }} />
                      <col />
                      <col style={{ width: "150px" }} />
                    </colgroup>

                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Nama Dimensi</th>
                        <th>ON / OFF</th>
                      </tr>
                    </thead>

                    <tbody>
                      {getData.length === 0 ? (
                        <tr>
                          <td
                            colSpan={3}
                            className="module-empty-state"
                          >
                            Data dimensi belum tersedia
                          </td>
                        </tr>
                      ) : (
                        getData.map((row, index) => (
                          <tr key={row?.id || index}>
                            <td className="text-center">
                              <span className="assessment-number-badge">
                                {(page - 1) * limit + index + 1}
                              </span>
                            </td>

                            <td>
                              {row?.name_dimensi || "-"}
                            </td>

                            <td className="text-center">
                              <div className="config-toggle-wrap">
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input config-dimension-switch"
                                    type="checkbox"
                                    checked={
                                      Number(row?.status) === 1
                                    }
                                    disabled={
                                      !permission.update &&
                                      storageLevel !== "developer" &&
                                      storageLevel !== "superadmin"
                                    }
                                    onChange={() =>
                                      handleToggle(row)
                                    }
                                  />
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}